import React from 'react'
import { email, github, linkedin } from '../../data/Constants'
import resume from '../../assets/VincentCai_Resume.pdf'
import './footer.css'

function Footer() {
  return (
    <div className="footer" id="socials">
      <h2>Let's Connect...</h2>
      <div className="footer-items">
        <div className="footer-items-socials">
          <p><a href={linkedin} target="_blank" rel="noreferrer">LinkedIn</a></p>
          <p><a href={github} target="_blank" rel="noreferrer">Github</a></p>
          <p><a href={email}>Email</a></p>
        </div>
        <div className="footer-items-copyright">
          <p>© 2024 Vincent Cai </p>
        </div>
      </div>
    </div>
  )
}

export default Footer
